import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ConfirmationPage from "../../components/History/Confirmation";
import ToastError from "../../components/Notification/ToastError";
import { authsignature, authsignatureform, storage } from "../../libs";
import { ValConf } from "../../validation/ConfValidation";

const initData = {
  bank_asal: null,
  account_number: "",
  account_name: "",
  bukti_transfer: "",
  transaction_id: "",
};

function Confirmation(props) {
  const id = props.match.params.id;
  const location = useLocation();
  const history = useHistory();
  const [bank, setBank] = useState([]);
  const [loadBank, setLoadBank] = useState(false);
  const [data, setData] = useState(initData);
  const [method, setMethod] = useState({}); // 1. Bayar Tempat, 2. Transfer, 3. QRIS
  const [file, setFile] = useState(undefined);

  const [isError, setError] = useState([]);
  const [loading, setLoading] = useState(false);

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  const GetBank = async () => {
    setLoadBank(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/bank`
      );

      if (Number(response.data.code) === 200) {
        let sort = await response.data.data.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );

        setBank(sort);
        setLoadBank(false);
      } else {
        setLoadBank(false);
        setOpen(true);
        setResponse("");
      }
    } catch (e) {
      setLoadBank(false);
      setOpen(true);
      setResponse("");
    }
  };

  const GetData = async () => {
    const auth = await storage();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/transaction/history/detail`,
        {
          transaction_id: id,
          reference: location.pathname.includes("pembelian") ? "2" : "1",
        },
        {
          headers: await authsignature(auth.token, {
            transaction_id: id,
            reference: location.pathname.includes("pembelian") ? "2" : "1",
          }),
        }
      );

      if (Number(response.data.code) === 200) {
        setMethod(
          response?.data?.data?.info_pembayaran?.payment_method_id ?? 0
        );
      } else {
        history.push("/page-not-found");
      }
    } catch (e) {
      history.push("/page-not-found");
    }
  };

  useEffect(() => {
    GetData();
    GetBank();
    setData({ ...data, transaction_id: id.toString() });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelect = (e) => {
    const value = e.target.value;
    setData({ ...data, bank_asal: value });
    setError([]);
  };

  const onChange = (e) => {
    const { name, value } = e.target;

    if (name === "account_number") {
      setData({ ...data, [name]: value.replace(/[^0-9]/g, "") });
      setError([]);
    } else {
      setData({ ...data, [name]: value });
      setError([]);
    }
  };

  const onFile = (e) => {
    if (e.target.files[0] !== undefined) {
      setFile(e.target.files[0]);
      setData({
        ...data,
        bukti_transfer: e.target.files[0].name,
      });

      setError([]);
    }
  };

  const onSubmit = async () => {
    setLoading(true);
    const error = await ValConf(data, file, method);
    if (error.length > 0) {
      setError(error);
      setLoading(false);
    } else {
      try {
        const auth = await storage();

        let newData = new FormData();
        let sendData = {};

        if (method === 2) {
          newData.append("bank_asal", data.bank_asal);
          newData.append("account_number", data.account_number);
          newData.append("account_name", data.account_name);
          newData.append("bukti_transfer", file);
          newData.append("transaction_id", Number(data.transaction_id));
        } else {
          newData.append("bukti_transfer", file);
          newData.append("transaction_id", Number(data.transaction_id));
        }

        if (method === 2) {
          sendData = {
            bank_asal: data.bank_asal,
            account_number: data.account_number,
            account_name: data.account_name,
            transaction_id: data.transaction_id,
          };
        } else {
          sendData = {
            transaction_id: data.transaction_id,
          };
        }

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/payment/check`,
          newData,
          { headers: await authsignatureform(auth.token, sendData) }
        );

        if (Number(response.data.code) === 200) {
          setLoading(false);
          if (location.pathname.includes("pembelian")) {
            history.push(`/history/detail/pembelian/${id}`);
          } else {
            history.push(`/history/detail/pemeriksaan/${id}`);
          }
        } else {
          setOpen(true);
          setResponse("");
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
        setOpen(true);
        setResponse("");
      }
    }
  };

  return (
    <>
      <ToastError props={{ open, response, onError }} />
      <ConfirmationPage
        props={{
          data,
          bank,
          loadBank,
          onSelect,
          onChange,
          isError,
          loading,
          onSubmit,
          onFile,
          method,
        }}
      />
    </>
  );
}

export default Confirmation;
